function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.625 0.5625V0.59375C10 0.4375 10.4375 0.5 10.7188 0.8125L15.7188 5.8125C16.0938 6.1875 16.0938 6.8125 15.7188 7.21875L10.7188 12.2188C10.4375 12.5 10 12.5938 9.625 12.4375C9.25 12.2812 9 11.9062 9 11.5V9H6C4.34375 9 3 10.3438 3 12C3 12.9375 3.40625 13.5 3.6875 13.7812C3.875 13.9375 4 14.1562 4 14.375C4 14.7188 3.71875 15 3.375 15C3.3125 15 3.21875 15 3.125 14.9375C2.5625 14.625 0 13.0312 0 9.5C0 6.46875 2.46875 4 5.5 4H9V1.5C9 1.09375 9.25 0.71875 9.625 0.5625Z",
  fill: "#006CA3"
});

function SvgNewWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.8em",
    height: "0.8em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindow);
export default __webpack_public_path__ + "static/media/new-window.c6974899.svg";
export { ForwardRef as ReactComponent };